import BaseButton from 'components/atoms/baseButton';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';

import s from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
}

const ErroneousButton: FC<Props> = ({ onClick, isLoading, disabled }) => {
  if (isLoading) {
    return (
      <BaseButton
        type="secondary"
        className={s['mark-erroneous-button']}
        icon={<ButtonLoadingIcon className={s['spin-loading-icon']} />}
        disabled
      />
    );
  }

  return (
    <BaseButton
      type="secondary"
      className={s['mark-erroneous-button']}
      icon={<ExclamationCircleOutlined />}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
export default ErroneousButton;
